import { i18n } from 'i18n';

export const VALIDATION_MESSAGES = {
	required: i18n.t('Field is required'),
	url: i18n.t('Url is not valid'),
	email: i18n.t('Email is not valid'),
	incorrectSymbols: i18n.t('Symbols is not valid'),
	telegram: i18n.t('Wrong contact link. Please write your Telegram number or link starts with t.me/...'),
	minlengthBigNumber: i18n.t('Ensure this field is at least {{count}} characters.'),
	maxlengthBigNumber: i18n.t('Ensure this field has no more than {{count}} characters.'),
};
